import { useDispatch, useSelector } from 'react-redux';
import { selectCyberCoverageLimit } from '../../../../selectors/application';
import { setCyberCoverage, setCheckedEndorsement } from '../../../../actions/application';
import { EndorsementKey } from '../../types';
import EndorsementSummaryCardLayout from '../../../Summary/Endorsements/EndorsementSummaryCardLayout';

const CyberInsuranceSummaryCard = ({ value }: { value: any }) => {
  const dispatch = useDispatch();
  const cyberCoverageLimit = useSelector(selectCyberCoverageLimit);
  const is25_50 = cyberCoverageLimit === '25000/50000';

  const coverageInfo = [
    { coverage: 'Coverage Form Aggregate', limit: is25_50 ? '$50,000' : '$100,000' },
    { coverage: 'Liability Coverage Limit', limit: is25_50 ? '$50,000' : '$100,000' },
    { coverage: 'First Party Coverage Limit', limit: is25_50 ? '$25,000' : '$50,000' },
  ];

  const handleRemove = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.CyberCoverage, false));
    dispatch(setCyberCoverage(null));
  };

  const handleRestore = () => {
    dispatch(setCheckedEndorsement(EndorsementKey.CyberCoverage, true));
    dispatch(setCyberCoverage(value));
  };

  return (
    <EndorsementSummaryCardLayout
      label="Cyber Insurance"
      coverageInfo={coverageInfo}
      onRemove={handleRemove}
      onRestore={handleRestore}
    />
  );
};

export default CyberInsuranceSummaryCard;
